import type { ReactNode } from 'react';

export const symbol_emergency_recording: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M370-428v108q0 12.75 8.68 21.37 8.67 8.63 21.5 8.63 12.82 0 21.32-8.63 8.5-8.62 8.5-21.37v-108l101 58q11 6 22.67 2.89 11.66-3.11 17.5-14Q577-392 574-404t-14-18l-100-58 100-58q11-6 14-18t-2.83-22.89q-5.84-10.89-17.5-14Q542-596 531-590l-101 58v-108q0-12.75-8.68-21.38-8.67-8.62-21.5-8.62-12.82 0-21.32 8.62-8.5 8.63-8.5 21.38v108l-101-58q-11-6-22.67-2.89-11.66 3.11-17.5 14Q223-568 226-556t14 18l100 58-100 58q-11 6-14 18t2.83 22.89q5.84 10.89 17.5 14Q258-364 269-370l101-58ZM140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h520q24 0 42 18t18 42v215l134-134q7-7 16.5-3.46T880-649v338q0 9.92-9.5 13.46Q861-294 854-301L720-435v215q0 24-18 42t-42 18H140Zm0-60h520v-520H140v520Zm0 0v-520 520Z"
		/>
	</svg>
);
